<template>
  <div class="order-page">
    <!-- <h1>超级推荐商品</h1> -->
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">

          <el-col :span="6">
            <el-form-item label-width
                          prop="plan"
                          label="计划">
              <el-input v-model="form.plan"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width
                          prop="create_time"
                          label="日期">
              <!-- <el-input v-model="form.create_time"></el-input> -->
              <el-date-picker v-model="form.create_time"
                              type="daterange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithImport"></action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="日期"
                       width="100px"></el-table-column>
      <el-table-column prop="plan"
                       align="center"
                       header-align="center"
                       label="计划"
                       min-width="130px"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="yxzx"
                       align="center"
                       header-align="center"
                       label="有效展现"></el-table-column>
      <el-table-column prop="yxdjs"
                       align="center"
                       header-align="center"
                       label="有效点击数"></el-table-column>
      <el-table-column prop="qczscb"
                       align="center"
                       header-align="center"
                       label="千次展现成本"></el-table-column>
      <el-table-column prop="xh"
                       align="center"
                       header-align="center"
                       label="消耗"></el-table-column>
      <el-table-column prop="djdj"
                       align="center"
                       header-align="center"
                       label="点击单价"></el-table-column>
      <el-table-column prop="ysddliang"
                       align="center"
                       header-align="center"
                       label="预售订单量"></el-table-column>
      <el-table-column prop="ysje"
                       align="center"
                       header-align="center"
                       label="预售金额"></el-table-column>
      <el-table-column prop="ctr"
                       align="center"
                       header-align="center"
                       label="点击率"></el-table-column>
					   
					   
	  <el-table-column prop="ctr"
                       align="center"
                       header-align="center"
                       label="点击率"></el-table-column>
      <el-table-column prop="ydjdliang"
                       align="center"
                       header-align="center"
                       label="引导进店量"></el-table-column>
      <el-table-column prop="ydjdlv"
                       align="center"
                       header-align="center"
                       label="引导进店率"></el-table-column>
      <el-table-column prop="ydjdrs"
                       align="center"
                       header-align="center"
                       label="引导进店人数"></el-table-column>			   
					   
					   
					   
	  <el-table-column prop="ydjdqkrs"
                       align="center"
                       header-align="center"
                       label="引导进店潜客人数"></el-table-column>
      <el-table-column prop="ydjdqkzb"
                       align="center"
                       header-align="center"
                       label="引导进店潜客占比"></el-table-column>
      <el-table-column prop="sdjdl"
                       align="center"
                       header-align="center"
                       label="深度进店量"></el-table-column>
      <el-table-column prop="pjfwsc"
                       align="center"
                       header-align="center"
                       label="平均访问时长"></el-table-column>		
				   
				   

	  <el-table-column prop="pjfwyms"
                       align="center"
                       header-align="center"
                       label="平均访问页面数"></el-table-column>
      <el-table-column prop="scdps"
                       align="center"
                       header-align="center"
                       label="收藏店铺数"></el-table-column>
      <el-table-column prop="gzdpl"
                       align="center"
                       header-align="center"
                       label="关注店铺量"></el-table-column>
      <el-table-column prop="xkhql"
                       align="center"
                       header-align="center"
                       label="新客获取量"></el-table-column>



	  <el-table-column prop="xkhqlv"
                       align="center"
                       header-align="center"
                       label="新客获取率"></el-table-column>
      <el-table-column prop="lxcb"
                       align="center"
                       header-align="center"
                       label="拉新成本"></el-table-column>
      <el-table-column prop="lxxh"
                       align="center"
                       header-align="center"
                       label="拉新消耗"></el-table-column>
      <el-table-column prop="scbbs"
                       align="center"
                       header-align="center"
                       label="收藏宝贝数"></el-table-column>	



	  <el-table-column prop="tjgwc"
                       align="center"
                       header-align="center"
                       label="添加购物车量"></el-table-column>
      <el-table-column prop="yhqlql"
                       align="center"
                       header-align="center"
                       label="优惠券领取量"></el-table-column>
      <el-table-column prop="wwzxl"
                       align="center"
                       header-align="center"
                       label="旺旺咨询量"></el-table-column>
      <el-table-column prop="pxddliang"
                       align="center"
                       header-align="center"
                       label="拍下订单量"></el-table-column>						   
				   
			

	  <el-table-column prop="pxddje"
                       align="center"
                       header-align="center"
                       label="拍下订单金额"></el-table-column>
      <el-table-column prop="cjddliang"
                       align="center"
                       header-align="center"
                       label="成交订单量"></el-table-column>
      <el-table-column prop="cjddje"
                       align="center"
                       header-align="center"
                       label="成交订单金额"></el-table-column>
      <el-table-column prop="zxzgkv"
                       align="center"
                       header-align="center"
                       label="展现转化率"></el-table-column>	
			
					   
	
		<el-table-column prop="djzhlv"
                       align="center"
                       header-align="center"
                       label="点击转化率"></el-table-column>
      <el-table-column prop="roi"
                       align="center"
                       header-align="center"
                       label="投资回报率"></el-table-column>	
					   

					   
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import handleExport from '@/common/mixins/handle-export'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin, handleExport],
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/promote/ad-goods/index.vue